(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/models/bigwininfo.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/models/bigwininfo.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.models.BigWinInfo = Backbone.Model.extend({
    defaults() {
      return {
        date: undefined,
        bigwinnerList: svs.map_of_winners.collections.BigWins
      };
    },
    initialize(attr, options) {
      this.set('bigwinnerList', new svs.map_of_winners.collections.BigWins(options.bigwinnerList, {
        model: svs.map_of_winners.models.BigWin,
        mapDimension: {
          mapHeight: options.mapHeight,
          mapWidth: options.mapWidth
        },
        immutable: true
      }));
    }
  });
})(Backbone, _, svs);

 })(window);